import { useState } from "react";
import { ShieldCheck, ChevronDown, ExternalLink } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { cn } from "@/lib/utils";
import { PREMIUM_PANEL, PanelGlow } from "./_styles";
import { trackMetaEvent } from "@/lib/metaPixel";

export default function PrivacyTrustCard() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  return (
    <section className={cn(PREMIUM_PANEL, "p-5")}>
      <PanelGlow />
      <div className="relative">
        <button
          type="button"
          onClick={() => {
            const next = !open;
            setOpen(next);
            if (next) void trackMetaEvent("parent_privacy_card_opened", { customData: {} });
          }}
          className="flex w-full items-center justify-between gap-3 text-left"
          aria-expanded={open}
        >
          <div className="flex items-center gap-2.5">
            <span className="flex h-8 w-8 items-center justify-center rounded-xl bg-primary/10 text-primary ring-1 ring-primary/20">
              <ShieldCheck className="h-4 w-4" />
            </span>
            <div>
              <p className="font-heading text-sm font-semibold text-foreground">Data & Privacy Trust Layer</p>
              <p className="text-[11px] text-muted-foreground">HeirWise never sells child data. Tap to review controls.</p>
            </div>
          </div>
          <ChevronDown className={cn("h-4 w-4 text-muted-foreground transition-transform", open && "rotate-180")} />
        </button>
        {open && (
          <div className="mt-4 space-y-3 border-t border-white/[0.05] pt-4">
            <p className="text-xs leading-relaxed text-foreground/85">
              HeirWise uses your teen's lesson progress, quiz performance, and simulation decisions to personalize learning and surface parent insights. We do not sell child data. All insights stay inside your household.
            </p>
            <div className="flex flex-wrap gap-2">
              <TrustLink onClick={() => navigate("/parent/privacy")}>Privacy controls</TrustLink>
              <TrustLink onClick={() => navigate("/data-deletion-request")}>Data deletion</TrustLink>
              <TrustLink onClick={() => navigate("/settings/security")}>Account security</TrustLink>
              <TrustLink onClick={() => navigate("/children-privacy-notice")}>Children's privacy notice</TrustLink>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}

function TrustLink({ children, onClick }: { children: React.ReactNode; onClick: () => void }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="inline-flex items-center gap-1.5 rounded-full border border-white/10 bg-background/40 px-3 py-1.5 text-xs font-medium text-foreground transition hover:bg-background/60"
    >
      {children}
      <ExternalLink className="h-3 w-3" />
    </button>
  );
}